import React from 'react'

function Item ({ item }) {
  return (
    <a
      href={ item.offsite ? item.url : 'https://oddert.github.io' + item.url }
      style={{ backgroundImageX: `url(${item.thumbnail})` }}
    >
      <div className="project">
        <img src={item.thumbnail} className='project__background' alt='background' />
        <div className="cover"></div>
        <h3 className="project__title" dangerouslySetInnerHTML={{ __html: item.title }}></h3>
        <p className="project__description">{ item.description }</p>
      </div>
    </a>
  )
}

export default Item
